// extracted by mini-css-extract-plugin
module.exports = {"star":"_6c97079b1b--star--SHOPN","underlay":"_6c97079b1b--underlay--PD7u5"};